<script setup lang="ts">
import { howItWorks } from '../../../content'
</script>

<template>
  <section id="how-it-works" class="how-it-works">
    <div class="container">
      <div class="section-header animate animate--fade-up">
        <h2 class="section-header__title">{{ howItWorks.headline }}</h2>
        <p class="section-header__description">{{ howItWorks.lead }}</p>
      </div>

      <div class="grid grid--4">
        <div
          v-for="(step, index) in howItWorks.steps"
          :key="step.number"
          class="animate animate--fade-up"
          :class="`animate--delay-${index + 1}`"
        >
          <div :class="['step-card', { 'step-card--primary': step.primary }]">
            <span class="step-card__number">{{ step.number }}</span>
            <div class="step-card__icon">{{ step.icon }}</div>
            <h3 class="step-card__title">{{ step.title }}</h3>

            <ul class="step-card__list">
              <li v-for="(item, idx) in step.items" :key="idx">
                <strong>{{ item.text }}</strong>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
